import tokens from './tokens.json';

/** Design tokens (docs/08). Web reads the generated CSS variables, mobile reads this object. No hex in components. */
export const T = tokens;
export type Tokens = typeof tokens;
export const color = tokens.color;
export const space = tokens.space;
export const radius = tokens.radius;
export const fontSize = tokens.fontSize;
export const motion = tokens.motion;
export * from './brand';
export * from './costIcons';
